import React from 'react';
import './Pages.css';

const programData = [
  {
    id: '1',
    title: "Capacity Building to New Innovation Space",
    description: "This program focuses on supporting institutions to establish their innovation space. This is a tailor-made program that helps the institutions to understand the \"Best Practices\" on how to establish innovation space.",
    image: "/assest/img/blog2.jpg",
    category: "Programs • Innovation Space"
  },
  {
    id: '2',
    title: "Mentorship to Existing Innovation Spaces",
    description: "The program supports the existing spaces through mentorship. The support is tailored according to the needs of the Hub in question.",
    image: "/assest/img/blog1.jpg",
    category: "Programs • Mentorship"
  },
  {
    id: '3',
    title: "Buni Talent Pool Program",
    description: "The program focuses on building talents with brilliant ideas that can have an impact on the community and can be useful to help companies to accelerate the work they do.",
    image: "/assest/img/vince.jpeg",
    category: "Programs • Talent Development"
  },
  {
    id: '4',
    title: "Buni Divaz Program",
    description: "This program is designed to increase women involvement in Technology, Innovation and Entrepreneurship. It also aspires to encourage a safe space for women participation in the Innovation Ecosystem.",
    image: "/assest/img/sham.png",
    category: "Programs • Women Empowerment"
  },
  {
    id: '5',
    title: "Linkages and Networking",
    description: "This program link and introduce our beneficiaries with potential stakeholders and government locally and international level.",
    image: "/assest/img/COSTECH-6.jpg",
    category: "Programs • Networking"
  }
];

function Programs() {
  return (
    <>
      <section className="programs-hero">
        <div className="programs-hero-container">
          <h1 className="programs-hero-title">Our Programs</h1>
          <p className="programs-hero-subtitle">
            Discover the comprehensive range of programs offered at BuniHub, designed to foster innovation, 
            support entrepreneurship, and build a thriving ecosystem for technology and business development.
          </p>
        </div>
      </section>

      <section className="programs-content">
        <div className="programs-container">
          <div className="programs-grid">
            {programData.map((program) => (
              <div className="program-card" key={program.id}>
                <div className="program-image">
                  <img src={program.image} alt={program.title} />
                </div>
                <div className="program-body">
                  <p className="program-category">{program.category}</p>
                  <h3 className="program-title">{program.title}</h3>
                  <p className="program-description">{program.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Programs;
